var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.game && _vm.bets && _vm.bets.length > 0
    ? _c("div", { staticClass: "wheel-sidebar-bets" }, [
        _c(
          "div",
          {
            staticClass: "user-bets",
            class: { "user-bets_sticky-bet": _vm.isStickyBet },
          },
          _vm._l(_vm.bets, function (bet) {
            return _c("SidebarBet", {
              key: bet.id,
              attrs: {
                bet: bet,
                "game-status": _vm.game.status,
                "win-color": _vm.game.winColor,
              },
            })
          }),
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }